<template>
  <el-dialog
    :title="isCreate ? '新增广告' : '编辑广告'"
    :visible="true"
    :before-close="closeForm"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="30%"
  >
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="广告编号" prop="advertisementNo">
        <el-input v-model.trim="ruleForm.advertisementNo"></el-input>
      </el-form-item>
      <el-form-item label="说明" prop="remark">
        <el-input v-model.trim="ruleForm.remark"></el-input>
      </el-form-item>
      <el-form-item label="链接" prop="url">
        <el-input v-model.trim="ruleForm.url"></el-input>
      </el-form-item>

      <el-form-item label="图片上传" prop="uploadImageUrl">
        <el-upload
          class="avatar-uploader"
          action="/api/shared/upload"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
        >
          <img v-if="uploadImageUrl" :src="uploadImageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <div class="align-center">
        <el-button type="primary" @click="submitForm()">确定</el-button>
        <el-button type="primary" v-if="isCreate" @click="submitForm(false)"
          >连续添加</el-button
        >
        <el-button @click="closeForm()">取消</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  props: ["isCreate", "advertisementInfo"],
  data() {
    return {
      uploadImageUrl:
        this.advertisementInfo && this.advertisementInfo.imageUrl
          ? "/api/shared/getImage?ossFileKey=" + this.advertisementInfo.imageUrl
          : "",
      ruleForm: {
        advertisementNo: this.advertisementInfo
          ? this.advertisementInfo.advertisementNo
          : "",
        remark: this.advertisementInfo ? this.advertisementInfo.remark : "",
        imageUrl: this.advertisementInfo ? this.advertisementInfo.imageUrl : "",
        url: this.advertisementInfo ? this.advertisementInfo.url : ""
      }
    };
  },
  methods: {
    submitForm() {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          let requestModel = {
            advertisementNo: this.ruleForm.advertisementNo,
            remark: this.ruleForm.remark,
            imageUrl: this.ruleForm.imageUrl,
            url: this.ruleForm.url,
            id: this.advertisementInfo ? this.advertisementInfo.id : undefined
          };
          let key = this.isCreate ? "新增广告" : "编辑广告";
          this.$axios(this.$urlMapping[key], {
            data: requestModel
            // eslint-disable-next-line no-unused-vars
          }).then(result => {
            this.$notifySuccess();
            this.$emit("closeForm");
            this.$emit("handleUpdate");
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    closeForm() {
      this.$emit("closeForm");
    },
    handleAvatarSuccess(res, file) {
      console.log(res);
      this.uploadImageUrl = URL.createObjectURL(file.raw);
      if (res.code == 0) {
        this.ruleForm.imageUrl = res.result.key;
      } else {
        this.$notify.error({
          title: "消息",
          message: "上传图片失败"
        });
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    handleChangeShopOwner() {
      this.ruleForm.projectid = "";
    }
  }
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 12px;
  color: #8c939d;
  width: 68px;
  height: 68px;
  line-height: 68px;
  text-align: center;
}
.avatar {
  width: 68px;
  height: 68px;
  display: block;
}
</style>
